import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { ViewController } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the CoSecurityPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-security-popover',
  templateUrl: 'co-security-popover.html'
})
export class CoSecurityPopoverComponent {

  locations: any;
  departments: any;
  messages: any;
  selectedId: number;
  selectedDepartments: any = [];
  selectedMessage: string = '';

  constructor(private navParams: NavParams, private viewCtrl: ViewController, private toast: ToastAlertsProvider) {
    this.locations = this.navParams.data.locations;
    this.departments = this.navParams.data.departments;
    this.messages = this.navParams.data.messages;
    if (this.navParams.data.chosenLocation) {
      this.selectedId = this.navParams.data.chosenLocation.id;
    }
    if (this.navParams.data.chosenDepartment) {
      this.navParams.data.chosenDepartment.forEach(department => {
        this.selectedDepartments[department.name] = true;
      });
    }
    if (this.navParams.data.chosenMessage) {
      this.selectedMessage = this.navParams.data.chosenMessage.name;
    }
  }

  close(apply?) {
    if (!apply) {
      this.viewCtrl.dismiss().catch(err=>{});
    } else {
      if (this.locations) {
        if (this.selectedId && this.selectedId > 0) {
          let currentItem;
          this.locations.forEach(location => {
            if (location.id.toString() === this.selectedId.toString()) {
              currentItem = location;
            }
          });
          this.viewCtrl.dismiss({data: currentItem});
        } else {
          this.toast.triggerToast('Please select a location', '', 'warning', 5000);
        }
      } else if (this.departments) {
          let currentItem;
          this.departments.forEach(department => {
            Object.keys(this.selectedDepartments).forEach(sDepartment => {
              if (department.name.toString() === sDepartment.toString() && this.selectedDepartments[sDepartment]===true) {
                if (!currentItem) {
                  currentItem = [];
                }
                currentItem.push(department);
              }
            });
          });
          if (!currentItem) {
            this.toast.triggerToast('Please select a department', '', 'warning', 5000);
            return;
          }
          this.viewCtrl.dismiss({data: currentItem});
      } else if (this.messages) {
        if (this.selectedMessage && this.selectedMessage.length > 0) {
          let currentItem;
          this.messages.forEach(message => {
            if (message.name === this.selectedMessage) {
              currentItem = message;
            }
          });

          if (!currentItem && this.selectedMessage === 'other') {
            currentItem = {name: 'Other', message:''};
          }
          this.viewCtrl.dismiss({data: currentItem});
        } else {
          this.toast.triggerToast('Please select an issue', '', 'warning', 5000);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-security-popover/co-security-popover.ts